import { render, staticRenderFns } from "./InventarioComponent.vue?vue&type=template&id=d789ece2&"
import script from "./InventarioComponent.vue?vue&type=script&lang=js&"
export * from "./InventarioComponent.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports